import React from "react";
import * as yup from "yup";
import { UploadTextField } from "../../../controls/UploadTextField/UploadTextField";
import { UserValidation } from "../../../../models/User";
import { useTranslation } from "react-i18next";
import { TFunction } from "i18next";

interface Props {}

export const StepTitle1 = (t: TFunction) => t("step1.title");
export const StepInstructions1 = (t: TFunction) => t("step1.instructions");
export const StepValidation1 = (t: TFunction) => {
  return yup.object({ user: UserValidation(t) });
};

export const Step1: React.FC<Props> = () => {
  const { t } = useTranslation();
  const name = t("step1.name")+" *";
  const email = t("step1.email")+" *";
  return (
    <>
      <div>
        <UploadTextField
          label={name}
          placeholder={name}
          name="user.name"
          id="name"
          type="text"
          autoComplete="on"
          autoFocus
        />
      </div>
      <div>
        <UploadTextField
          label={email}
          placeholder={email}
          name="user.email"
          id="email"
          type="email"
          autoComplete="on"
        />
      </div>
    </>
  );
};
